<template>
  <b-modal
    :id="id"
    size="xl"
    :title="this.$translate(title)"
    hide-footer
    centered
    content-class="rounded-8"
    @close="clear"
    @show="show"
    @hide="hide"
  >
    <div class="row">
      <div v-for="i in upsert" :key="i.value" :class="` col-lg-6 col-sm-12 col-xs-12 ${i.type === 'color' ? 'center-color' : ''}`">
        <Input
          v-if="!i.type || i.type === 'input'"
          v-model="data[i.value]"
          :form-group-id="i.name"
          :placeholder="i.name"
          :error="i.phoneValidation && !!data[i.value] && (onValidationPhone(i.value))"
          :required="i.required"
          :customID="i.name"
        />
        <Select
          v-if="i.type === 'select'"
          v-model="data[i.value]"
          :options="i.data"
          :form-group-id="i.name"
          :placeholder="i.name"
          :required="i.required"
          :customID="i.name"
        />
        <Multiselect
          v-if="i.type === 'multiselect'"
          :options="i.data"
          :init-values="data[i.value] ? data[i.value].map(o => ({ text: o.name, value: o.id })) : []"
          :form-group-id="i.name"
          :placeholder="i.name"
          placeholder-input="Select Users"
          :required="i.required"
          :customID="i.name"
          :on-change="v => (data[i.value] = v)"
        />
        <Chrome v-if="i.type === 'color'" v-model="data[i.value]" />
      </div>

      <div class="row mx-0 w-100">
        <div class="col-12 col-lg-12 col-sm-12 col-xs-12 button-wrapper">
          <b-button
            variant="outline-secondary"
            size="lg"
            class="btn-delete-device px-5"
            @click="close"
          >
            {{ 'Close' | i18n }}
          </b-button>
          <b-button
            variant="outline-primary"
            size="lg"
            class="btn-delete-device ml-4 px-5"
            :disabled="submitDissabled"
            @click="onSubmit"
          >
            {{ 'Save' | i18n }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from '../common/input';
import Select from '../common/select';
import Multiselect from '../common/multiselect';

import { NotificationMixin } from '../../../mixins';
import Notification from '../common/notification';
import { Chrome } from 'vue-color';

export default {
  title: 'Upsert instance',
  components: { Input, Select, Chrome, Multiselect },
  mixins: [NotificationMixin],
  props: {
    getPage: {
      type: Function,
      default: () => {}
    },
    onSave: {
      type: Function,
      default: () => {}
    },
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    initData: {
      type: Object,
      default: () => {}
    },
    upsert: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      data: {},
      preventCloseLocal: true,
      initDataForCheck: {}
    };
  },
  computed: {
    submitDissabled: function() {
      let isDissabled = false;
      this.upsert.forEach(u => {
        if (u.required && !this.data[u.value]) {
          isDissabled = true;
        }
      });
      return isDissabled;
    },
  },
  methods: {
    onValidationPhone(fieldName) {
      const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
      let validation = false;

      switch (fieldName) {
        case 'phone':
          validation = !phoneRegex.test(this.data.phone);
          break;
        case 'telephoneNumber':
          validation = !phoneRegex.test(this.data.telephoneNumber);
          break;
        case 'mobileNumber':
          validation = !phoneRegex.test(this.data.mobileNumber);
          break;
        default:
          validation = false;
      }

      return validation;
    },
    async show() {
      this.clear();
      if (this.type === 'edit') {
        this.data = JSON.parse(JSON.stringify(this.initData));
        console.log(this.initData, 'this.initData');
        this.upsert.forEach(u => {
          if (u.type === 'select' && this.initData[u.value]) {
            const id = this.initData[u.value].id;
            this.data[u.value] = id ? id : this.initData[u.value];
          }
          if (u.type === 'color') {
            this.data[u.value] = { hex8: this.initData[u.value] || '' };
          }
        });
      } else {
        this.upsert.forEach(u => {
          if (u.type === 'color') {
            this.data[u.value] = { hex8: '' };
          }
        });
      }
      this.initDataForCheck = Object.assign({}, this.data);
    },
    close() {
      this.$root.$emit('bv::hide::modal', this.id);
    },
    clear() {
      this.data = {};
    },
    hide(e) {
      let isModified = true;
      if (this.type === 'add') {
        const lengthCurrent = Object.keys(this.data).length;
        const lengthInit = Object.keys(this.initDataForCheck).length;
        if (lengthCurrent == lengthInit) {
          isModified = false;
        }
      }

      if (this.type === 'edit') {
        isModified = false;
        Object.keys(this.data).map(key => {
          if (this.data[key] !== this.initDataForCheck[key]) {
            isModified = true;
          }
        });
      }

      if (this.preventCloseLocal && isModified) {
        let message = confirm(this.$translate('You have not saved your progress Are you sure you want to leave this page'));
        if (!message) {
          return e.preventDefault();
        }
        this.clear();
      }
    },
    async onSubmit() {
      try {
        this.preventCloseLocal = false;
        const p = { ...this.data };
        this.upsert.forEach(u => {
          if (u.type === 'color') {
            p[u.value] = this.data[u.value] ? this.data[u.value].hex8 : '';
          }
          if (u.type === 'multiselect') {
            p[u.value] = this.data[u.value] ? this.data[u.value].map(o => o.id || o.value) : [];
          }
        });
        const payload = p;
        await this.onSave(payload);
        this.$root.$emit('bv::hide::modal', this.id);
        await this.getPage();
        Notification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        Notification({ type: 'error', message: err.message });
        this.preventCloseLocal = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep  #add-customer .modal-dialog {
  max-width: 700px !important;
}

::v-deep  .button-wrapper {
  display: flex;
  justify-content: flex-end;
}

.center-color {
  justify-content: center;
  align-items: center;
  display: flex;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
